import { ApiResult, CrudService, Meta } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OperadorEstrangeiroEntity, SolicitacaoProcessamentoEntity } from '@catalogo/models';
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";
import { EnumTipoArquivo } from "@catalogo/features/operacional/enums/enum-entities";

@Injectable({ providedIn: 'root' })
export class OperadorEstrangeiroDataService extends CrudService<OperadorEstrangeiroEntity> {
  protected url: string;

  constructor(
    @Inject(OPERACAO_API_URL) urlBase: string,
    @Inject(HttpClient) protected httpClient: HttpClient
  ) {
    super(urlBase, httpClient);
    this.url = `${urlBase}/v1/operadorestrangeiro`;
  }

  public importar = (payload: FormData) => this.httpClient.post<any>(`${this.url}/Importar`, payload);
  public solicitarCapturaPortalUnico = (payload: FormData) =>
      this.httpClient.post<any>(`${this.url}/Captura/PortalUnico`, payload);
  public obterUltimaSolicitacao = () => this.httpClient.get<ApiResult<SolicitacaoProcessamentoEntity>>(this.url + '/Importar/Atual');
  public obterUltimaSolicitacaoPortalUnico = () => this.httpClient.get<ApiResult<SolicitacaoProcessamentoEntity>>(this.url + '/Captura/PortalUnico/Atual');
  public downloadRetornoImportacaoPlanilha = () => this.httpClient.get<ApiResult<any>>(`${this.url}/Importar/Retorno`);

  public exportar = (meta: Meta, tipoArquivo: EnumTipoArquivo) => this.httpClient.post<any>(`${this.url}/Exportar`, {...meta, tipoArquivo});
  public obterUltimaSolicitacaoExportacao = () => this.httpClient.get<ApiResult<SolicitacaoProcessamentoEntity>>(this.url + '/Exportar/Atual');
  public downloadRetornoExportacaoPlanilha = () =>
    this.httpClient.get(`${this.url}/Exportar/Retorno`, {
        observe: 'response',
        responseType: 'blob'
    });
}
